<template>
  <div class="banner">
    <div class="banner-carousel">
      <el-carousel>
        <el-carousel-item v-for="item in bannerList" :key="item.id">
          <img :src="item.pic" alt="" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="wrap banner-wrap">
      <div class="menu-list">
      </div>
    </div>
  </div>
</template>

<script>
import { getBanner } from "@/api/home";
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "banner",
  data() {
    return {
      //课程分类数据
      // categories: [{
      //         name: "个人发展",
      //         subcategories: [{
      //             name: "传统文化",
      //             subcategories: [{
      //                 name: "国学"
      //             }],
      //         }, ],
      //     },
      //     {
      //         name: "领导力",
      //         subcategories: [{
      //                 name: "领导他人",
      //                 subcategories: [{
      //                     name: "识人用人"
      //                 }],
      //             },
      //             {
      //                 name: "领导组织",
      //                 subcategories: [{
      //                     name: "组织领导力"
      //                 }],
      //             },
      //         ],
      //     },
      //     {
      //         name: "生产管理",
      //         subcategories: [{
      //             name: "现场管理",
      //             subcategories: [{
      //                 name: "现场安全"
      //             }],
      //         }, ],
      //     },
      //     {
      //         name: "财务管理",
      //         subcategories: [{
      //             name: "会计准则",
      //             subcategories: [{
      //                 name: "会计准则解析"
      //             }],
      //         }, ],
      //     },
      //     {
      //         name: "职业化",
      //         subcategories: [{
      //             name: "职业技能",
      //             subcategories: [{
      //                 name: "人际交往"
      //             }, {
      //                 name: "效能提升"
      //             }],
      //         }, ],
      //     },
      //     {
      //         name: "综合管理",
      //         subcategories: [{
      //                 name: "管理基础",
      //                 subcategories: [{
      //                     name: "目标管理"
      //                 }],
      //             },
      //             {
      //                 name: "运营管理",
      //                 subcategories: [{
      //                     name: "模式设计"
      //                 }, {
      //                     name: "内部控制"
      //                 }],
      //             },
      //         ],
      //     },
      //     {
      //         name: "监理工程师"
      //     },
      //     {
      //         name: "一级造价师"
      //     },
      //     {
      //         name: "二级建造师继续教育"
      //     },
      // ],
      bannerList: [],
    };
  },
  created() {
    this.getBannerList();
  },
  methods: {
    //跳转到对应课程分类
    // goAllSubject() {
    //   let routeData = this.$router.resolve({
    //     name: "allSubject",
    //   });
    //   window.open(routeData.href, "_blank");
    // },
    goAllSubject(category, subcategory = null, thirdCategory = null) {
      let query = {
        category,
      };
      if (subcategory) query.subcategory = subcategory;
      if (thirdCategory) query.thirdCategory = thirdCategory;
      this.$router.push({
        name: "allSubject",
        query,
      });
    },
    // 获取轮播图
    async getBannerList() {
      try {
        const res = await getBanner();
        const { banner } = res.data;
        if (res) {
          this.bannerList = banner;
        }
      } catch (error) {}
    },
  },
};
</script>

<style lang="scss" scoped>
.banner {
  height: auto;
  margin-top: 65px;
  position: relative;
  margin-bottom: 20PX;
}

.banner-carousel {
  // height: 470px;

  //position: absolute;
  //top: 0;
  //left: 0;
  //width: 100%;
  //height: 100%;
  //z-index: 1;
  img {
    width: 100%;
    height: 100%;
  }
}

.banner-wrap {
  position: relative;
  z-index: 10;

  .menu-list {
    position: relative;

    .menu-title {
      width: 200px;
      padding: 6px 20px;
      background-color: rgba(0, 0, 0, 0.9);
      color: #fff;
      cursor: pointer;
      font-size: 14px;

      .menu-title-text {
        margin-left: 6px;
      }
    }

    .menu-item {
      width: 200px;
      padding: 16px 20px;
      background-color: rgba(0, 0, 0, 0.6);
      color: #fff;
      cursor: pointer;
      font-size: 14px;

      .custom-right-icon {
        float: right;
        position: relative;
        right: 10px;
        top: 5px;
        // transform: translateY(-50%);
        font-size: 12px;
      }

      .menu-sub-list {
        display: none;
        position: absolute;
        left: 200px;
        top: 0;
        width: 200px;
        height: 470px;
        background-color: rgba(0, 0, 0, 0.6);

        .menu-sub-item {
          position: relative;
          width: 200px;
          padding: 14px 20px;
          color: #fff;
          cursor: pointer;
          font-size: 14px;

          .custom-right-icon {
            position: absolute;
            right: 10px;
            top: 50%;
            transform: translateY(-50%);
            font-size: 12px;
          }

          .menu-third-list {
            display: none;
            position: absolute;
            left: 200px;
            top: 0;
            width: 200px;
            height: 470px;
            background-color: rgba(0, 0, 0, 0.6);

            .menu-third-item {
              position: relative;
              width: 200px;
              padding: 14px 20px;
              color: #fff;
              cursor: pointer;
              font-size: 14px;

              .custom-right-icon {
                position: absolute;
                right: 10px;
                top: 50%;
                transform: translateY(-50%);
                font-size: 12px;
              }
            }

            .menu-third-item:hover {
              background-color: #558ad6;
            }
          }
        }

        .menu-sub-item:hover {
          background-color: #558ad6;
        }

        .menu-sub-item:hover .menu-third-list {
          display: block;
        }

        .menu-sub-item:nth-child(2) .menu-third-list {
          top: -47px;
        }
      }
    }

    .menu-item:hover {
      background-color: #558ad6;
    }

    .menu-item:hover .menu-sub-list {
      display: block;
    }
  }
}

@media (max-width: 600px) {
  .banner-carousel {
    // height: 270px !important;
  }
}
</style>
